import { Message } from 'element-ui'

const getDefaultState = () => {
  const jdUrl = localStorage.getItem('jd_url')
  const jdName = localStorage.getItem('jd_name')
  const cvUrl = localStorage.getItem('cv_url')
  const cvName = localStorage.getItem('cv_name')

  return {
    interviewDuration: 0,
    actualInterviewDuration: 0, // 新增：实际面试时长（分钟）
    interviewLanguage: '', // 新增：存储面试语言
    usingBeautifys: [],
    usingFilter: null,
    usingBackground: null,
    interviewStarted: false,
    interviewScore: 0,
    body_language: 0,
    facial_expression: 0,
    grooming: 0,
    interview_tone: 0,
    timely_response: 0,
    content: 0,
    interviewId: '',
    recommendId: '', // 新增：存储推荐任务ID
    jd: jdUrl ? { url: jdUrl, name: jdName } : null,
    cv: cvUrl ? { url: cvUrl, name: cvName } : null,
    dialogues: [],
    firstDialogue: true,
    prompt: null,
    formattedDialogues: '', 
    rawDialogues: [],       // 新增原始对话数据备份
    processedVideoBlob: null, // 新增：处理后的视频文件
    processedTextBlob: null,  // 新增：处理后的文本文件
    recommendVideos: [], // 新增：视频推荐结果
    generateJsonData: null, // 新增：getGenerateJson返回的数据
    generateJsonLoading: false, // 新增：getGenerateJson加载状态
    interviewSummary: null, // 新增：面试总结数据
    promptLoading: false,
    promptError: null,
    reportUrl: null, // 面试解析报告
    currentInterviewJob: null,
    advantages: [], // 面试优点
    disadvantages: [], // 面试缺点
  }
}



const state = getDefaultState()

const mutations = {
  SET_FORMATTED_DIALOGUES: (state, formattedText) => {
    state.formattedDialogues = formattedText
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_INTERVIEW_DURATION: (state, duration) => {
    state.interviewDuration = duration
  },
  SET_ACTUAL_INTERVIEW_DURATION: (state, duration) => {
    state.actualInterviewDuration = duration
  },
  SET_INTERVIEW_LANGUAGE: (state, language) => { // 新增：设置面试语言
    state.interviewLanguage = language
  },
  SET_USING_BEAUTIFYS: (state, beautifys) => {
    state.usingBeautifys = beautifys
  },
  SET_USING_FILTER: (state, filter) => {
    state.usingFilter = filter
  },
  SET_USING_BACKGROUND: (state, background) => {
    state.usingBackground = background
  },
  SET_PROMPT(state, prompt) {
    state.prompt = prompt
  },
  SET_INTERVIEW_STARTED: (state, started) => {
    state.interviewStarted = started
    if (started) {
      state.interviewScore = 0
      state.body_language = 0
      state.facial_expression = 0
      state.grooming = 0
      while (state.dialogues.length > 0) { state.dialogues.pop() }
      state.firstDialogue = true
    }
  },
  SET_INTERVIEW_SCORE: (state, data) => {
    
    // 如果数据是对象格式（新的评分格式），直接存储整个对象
    if (data && typeof data === 'object' && !data.score) {
      state.interviewScore = data
    }
  },
  SET_INTERVIEW_ID: (state, id) => {
    state.interviewId = id
  },
  SET_RECOMMEND_ID: (state, id) => {
    state.recommendId = id
  },
  SET_JD: (state, jd) => {
    state.jd = jd
    // 保存URL和文件名到localStorage
    if (jd && jd.url) {
      localStorage.setItem('jd_url', jd.url)
      localStorage.setItem('jd_name', jd.name || 'job_description.txt')
    } else {
      localStorage.removeItem('jd_url')
      localStorage.removeItem('jd_name')
    }
  },
  SET_CV: (state, cv) => {
    state.cv = cv
    // 保存URL和文件名到localStorage
    if (cv && cv.url) {
      localStorage.setItem('cv_url', cv.url)
      localStorage.setItem('cv_name', cv.name || 'resume.pdf')
    } else {
      localStorage.removeItem('cv_url')
      localStorage.removeItem('cv_name')
    }
  },
  SET_DIALOGUES: (state, dialogue) => {
    if (state.firstDialogue) {
      state.firstDialogue = false
    } else {
      state.dialogues.push(dialogue)
      state.rawDialogues.push(dialogue) // 备份原始数据
    }
  },
  CLEAR_DIALOGUES: (state) => {
    while (state.dialogues.length > 0) state.dialogues.pop()
    state.rawDialogues = []         // 清除原始数据
    state.formattedDialogues = ''    // 清除格式化文本
  },
  SET_PROCESSED_VIDEO: (state, videoBlob) => {
    state.processedVideoBlob = videoBlob
  },
  SET_PROCESSED_TEXT: (state, textBlob) => {
    state.processedTextBlob = textBlob
  },
  SET_RECOMMEND_VIDEOS: (state, videos) => {
    state.recommendVideos = Array.isArray(videos) ? videos : []
  },
  SET_GENERATE_JSON_DATA: (state, data) => {
    state.generateJsonData = data
  },
  SET_GENERATE_JSON_LOADING: (state, loading) => {
    state.generateJsonLoading = loading
  },
  SET_INTERVIEW_SUMMARY: (state, summary) => {
    state.interviewSummary = summary
  },
  SET_PDF_URL: (state, url) => {
    state.reportUrl = url
  },
  SET_PROMPT_LOADING: (state, loading) => {
    state.promptLoading = loading
  },
  SET_PROMPT_ERROR: (state, error) => {
    state.promptError = error || null
  },
  SET_CURRENT_INTERVIEW_JOB(state, job) {
    state.currentInterviewJob = job ? { ...job } : null
  },
  CLEAR_CURRENT_INTERVIEW_JOB(state) {
    state.currentInterviewJob = null
  },
  SET_ADVANTAGES(state, advantages) {
    state.advantages = Array.isArray(advantages) ? advantages : []
  },
  SET_DISADVANTAGES(state, disadvantages) {
    state.disadvantages = Array.isArray(disadvantages) ? disadvantages : []
  }
}

const actions = {
  // 仅重置与单次面试过程强相关的临时数据，避免影响面试时长等全局配置
  resetInterviewState({ commit }) {
    // 清空对话与格式化文本
    commit('CLEAR_DIALOGUES')
    // 标记未开始面试
    commit('SET_INTERVIEW_STARTED', false)
    // 清空处理后的视频 / 文本
    commit('SET_PROCESSED_VIDEO', null)
    commit('SET_PROCESSED_TEXT', null)
    // 清空推荐结果（保留 recommendId，避免打断已创建的推荐任务）
    commit('SET_RECOMMEND_VIDEOS', [])
    // 清空 prompt，避免使用上一次面试的 prompt
    commit('SET_PROMPT', null)
    commit('SET_PROMPT_ERROR', null)
    // 清空解析报告与总结
    commit('SET_PDF_URL', null)
    commit('SET_INTERVIEW_SUMMARY', null)
    // 清空优缺点（当前面试岗位保留，由热门岗位页面传入并在分析页使用）
    commit('SET_ADVANTAGES', [])
    commit('SET_DISADVANTAGES', [])
  },
  formatDialogues({ commit, state }) {
    return new Promise((resolve) => {
      const formattedText = state.rawDialogues.reduce((acc, item) => {
        const normalizedUserId = item.userId.replace(/[＿_]/g, '')
        const isInterviewer = normalizedUserId === "RobotMan"
        const prefix = isInterviewer ? '[面试官] ' : '[候选人] '
        return acc + `${prefix}${item.text}\n`
      }, '').trimEnd()
      commit('SET_FORMATTED_DIALOGUES', formattedText)
      resolve(formattedText)
    })
  },
  setInterviewDuration({ commit }, duration) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_DURATION', duration)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setActualInterviewDuration({ commit }, duration) {
    return new Promise((resolve, reject) => {
      commit('SET_ACTUAL_INTERVIEW_DURATION', duration)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setInterviewLanguage({ commit }, language) { // 新增：设置面试语言
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_LANGUAGE', language)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setPrompt({ commit }, prompt) {
    commit('SET_PROMPT', prompt)
  },
  setCameraSetting({ commit }, data) {
    const { usingBeautifys, usingFilter, usingBackground } = data
    return new Promise((resolve, reject) => {
      commit('SET_USING_BEAUTIFYS', usingBeautifys)
      commit('SET_USING_FILTER', usingFilter)
      commit('SET_USING_BACKGROUND', usingBackground)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setInterviewId({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_ID', id)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setRecommendId({ commit }, id) {
    return new Promise((resolve, reject) => {
      commit('SET_RECOMMEND_ID', id)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  startInterview({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_STARTED', true)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setInterviewScore({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_SCORE', data)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  stopInterview({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_INTERVIEW_STARTED', false)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setJdCv({ commit }, data) {
    const { jd, cv } = data
    return new Promise((resolve, reject) => {
      commit('SET_JD', jd)
      commit('SET_CV', cv)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  dialogueInteract({ commit }, data) {
    const { original_text, processed_text_from_llm } = data
    return new Promise((resolve) => {
      commit('SET_DIALOGUES', original_text)
      commit('SET_DIALOGUES', processed_text_from_llm)
      dispatch('formatDialogues').then(resolve) // 自动触发格式化
    })
  },
  clearDialogues({ commit }) {
    return new Promise((resolve, reject) => {
      commit('CLEAR_DIALOGUES')
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  dialogueFeedback({ commit }, data) {
    const { answer, feedback, question } = data
    return new Promise((resolve, reject) => {
      commit('SET_DIALOGUES', question)
      commit('SET_DIALOGUES', answer)
      commit('SET_DIALOGUES', feedback)
      resolve()
    }).catch(error => {
      reject(error)
    })
  },
  setProcessedVideo({ commit }, videoBlob) {
    return new Promise((resolve) => {
      commit('SET_PROCESSED_VIDEO', videoBlob)
      resolve()
    })
  },
  setProcessedText({ commit }, textBlob) {
    return new Promise((resolve) => {
      commit('SET_PROCESSED_TEXT', textBlob)
      resolve()
    })
  },
  async fetchGenerateJson({ commit, state }) {
    try {
      commit('SET_GENERATE_JSON_LOADING', true)
      
      // 动态导入getGenerateJson API
      const { getGenerateJson } = await import('@/api/recommend')
      
      const { data } = await getGenerateJson({
        jd_url: state.jd?.url || "",
        resume_url: state.cv?.url || "",
      })
      
      console.log('getGenerateJson响应:', data)
      
      if (data.code === 1) {
        commit('SET_GENERATE_JSON_DATA', data.data)
        return data.data
      } else {
        console.warn('getGenerateJson返回失败:', data.msg)
        commit('SET_GENERATE_JSON_DATA', null)
        return null
      }
    } catch (error) {
      console.error('调用getGenerateJson失败:', error)
      commit('SET_GENERATE_JSON_DATA', null)
      // 不抛出错误，避免阻塞用户操作
      return null
    } finally {
      commit('SET_GENERATE_JSON_LOADING', false)
    }
  },
  async generatePromptInBackground({ commit, state }, { jdUrl, cvUrl } = {}) {
    const maxRetries = 3
    const jobUrl = jdUrl || state.jd?.url
    const resumeUrl = cvUrl || state.cv?.url

    if (!jobUrl || !resumeUrl) {
      return null
    }

    commit('SET_PROMPT_ERROR', null)
    commit('SET_PROMPT_LOADING', true)

    try {
      const aiModule = await import('@/api/ai')
      const generatePrompt = aiModule.generatePrompt
      const requestData = {
        jobDescriptionContent: jobUrl,
        resumeContent: resumeUrl
      }

      let lastError = null

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          const response = await generatePrompt(requestData)
          const data = response && response.data && response.data.data

          if (data && data.prompt) {
            commit('SET_PROMPT', data.prompt)
            if (data.interview_id) {
              commit('SET_INTERVIEW_ID', data.interview_id)
            }
            return data
          } else {
            lastError = new Error('Invalid prompt response')
            console.error(`generatePromptInBackground attempt ${attempt} failed:`, lastError)
          }
        } catch (error) {
          lastError = error
          console.error(`generatePromptInBackground attempt ${attempt} failed:`, error)
        }

        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, attempt * 1000))
        }
      }

      if (lastError) {
        commit('SET_PROMPT_ERROR', lastError)
      }
      return null
    } catch (error) {
      console.error('generatePromptInBackground failed (module or unexpected error):', error)
      commit('SET_PROMPT_ERROR', error)
      return null
    } finally {
      commit('SET_PROMPT_LOADING', false)
    }
  },
  setInterviewSummary({ commit }, summary) {
    commit('SET_INTERVIEW_SUMMARY', summary)
  },
  setReportUrl({ commit }, reportUrl) {
    commit('SET_PDF_URL', reportUrl)
  },
  setCurrentInterviewJob({ commit }, job) {
    commit('SET_CURRENT_INTERVIEW_JOB', job)
  },
  clearCurrentInterviewJob({ commit }) {
    commit('CLEAR_CURRENT_INTERVIEW_JOB')
  },
  setAdvantages({ commit }, advantages) {
    commit('SET_ADVANTAGES', advantages)
  },
  setDisadvantages({ commit }, disadvantages) {
    commit('SET_DISADVANTAGES', disadvantages)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}